/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StatsBillingGetResponse } from './StatsBillingGetResponse';
import {
    StatsBillingGetResponseFromJSON,
    StatsBillingGetResponseFromJSONTyped,
    StatsBillingGetResponseToJSON,
} from './StatsBillingGetResponse';

/**
 * 
 * @export
 * @interface GetStatsBilling200ResponseAllOf
 */
export interface GetStatsBilling200ResponseAllOf {
    /**
     * 
     * @type {StatsBillingGetResponse}
     * @memberof GetStatsBilling200ResponseAllOf
     */
    result: StatsBillingGetResponse;
}

/**
 * Check if a given object implements the GetStatsBilling200ResponseAllOf interface.
 */
export function instanceOfGetStatsBilling200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetStatsBilling200ResponseAllOfFromJSON(json: any): GetStatsBilling200ResponseAllOf {
    return GetStatsBilling200ResponseAllOfFromJSONTyped(json, false);
}

export function GetStatsBilling200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStatsBilling200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': StatsBillingGetResponseFromJSON(json['result']),
    };
}

export function GetStatsBilling200ResponseAllOfToJSON(value?: GetStatsBilling200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': StatsBillingGetResponseToJSON(value.result),
    };
}

